import React from "react";
import "./TagCloud.css";



const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      <h3>WHAT'S NEW IN UI/UX IN 2022</h3>
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Communication in UI/UX</p>
          <p className="item-2">Design System</p>
          <p className="item-3">How to avoid miscommunication in UI/UX</p>
          <p className="item-4">Leadership</p>
          <p className="item-5">Accessibility in UI/UX</p>
          <p className="item-6">Newest tools</p>
          <p className="item-7">Unspoken rules</p>
          <p className="item-8">Relevance in design</p>
          <p className="item-9">Future comes with AI</p>
          <p className="item-10">Skill up to find your niche</p>
          <p className="item-11">Make it motion</p>
          <p className="item-12">Design thinking</p>
          <p className="item-13">Determine your journey for the career</p>
        </div>
      </div>
    </div>
  );
};
export default TagCloud;
